import { useDispatch } from 'react-redux';
import { type AppDispatch } from 'src/store/rootStore';

export const useAppDispatch: () => AppDispatch = useDispatch
